import platform from "platform"
import { ReactNode } from "react"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { AppDispatch } from "store/index"
import { setDeviceInfo } from "store/slices/deviceInfoSlice"

type Props = {
  children: ReactNode
}

export const DeviceInfoProvider = ({ children }: Props) => {
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    const info = {
      deviceType: /Mobile/i.test(platform.description || "")
        ? "mobile"
        : "desktop",
      os: platform.os?.family || "Uknown",
      osVersion: platform.os?.version || "Unknown"
    }

    dispatch(setDeviceInfo(info))
  }, [dispatch])

  return <>{children}</>
}
